var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.717392 18.4353C0.717392 28.4885 8.86711 36.6382 18.9203 36.6382C28.9735 36.6382 37.1232 28.4885 37.1232 18.4353C37.1232 8.38214 28.9735 0.232422 18.9203 0.232422C8.86711 0.232422 0.717392 8.38214 0.717392 18.4353Z",
    fill: "#212529"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9145 27.5366H10.0464V15.3635H13.9145V27.5366ZM11.9804 13.6569C10.729 13.6569 9.81882 12.7468 9.81882 11.4953C9.81882 10.2439 10.8427 9.33374 11.9804 9.33374C13.2319 9.33374 14.142 10.2439 14.142 11.4953C14.142 12.7468 13.2319 13.6569 11.9804 13.6569ZM28.0217 27.5366H24.1536V20.9381C24.1536 19.004 23.3572 18.4352 22.2195 18.4352C21.0819 18.4352 19.9442 19.3453 19.9442 21.0519V27.5366H16.0761V15.3635H19.7166V17.07C20.058 16.2736 21.4232 15.0221 23.3572 15.0221C25.5188 15.0221 27.7942 16.2736 27.7942 20.0279V27.5366H28.0217Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.05ec8505ba94afbf7968431f63042065.svg";
export { ForwardRef as ReactComponent };